import { createAction, props } from '@ngrx/store';

export const listId = createAction('listId', props<{ data: any }>());
export const typeName = createAction('typeName', props<{ data: any }>());
export const orderNumber = createAction('orderNumber', props<{ data: any }>());
